namespace TabAurous.Stock {
    export namespace OwnStockKaratWiseService {
        export const baseUrl = 'Stock/OwnStockKaratWise';

        export declare function List(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<Stock.Repositories.OwnStockKaratWise>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Stock/OwnStockKaratWise/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>OwnStockKaratWiseService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
